import { render, staticRenderFns } from "./BindingCard.vue?vue&type=template&id=965668e4&scoped=true"
import script from "./BindingCard.vue?vue&type=script&lang=js"
export * from "./BindingCard.vue?vue&type=script&lang=js"
import style0 from "./BindingCard.vue?vue&type=style&index=0&id=965668e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965668e4",
  null
  
)

export default component.exports